import { GoalBox } from 'pages/newPost/components/GoalPreview/GoalBox'

interface PostGoalProps {
    goalData: any
    setTip: (_value: number) => void
    isMyPost: boolean
    disabled: boolean
}

export const PostGoal = ({
    goalData,
    setTip,
    isMyPost = false,
    disabled
}: PostGoalProps) => {
    return (
        <div className='post__goal'>
            <GoalBox
                title={goalData.text}
                tipped={goalData.tipped}
                goal={goalData.goal}
                options={[5, 10, 15]}
                setTip={setTip}
                isMyPost={isMyPost}
                disabled={disabled}
            />
        </div>
    )
}
